import { render, staticRenderFns } from "./big-tree-list.vue?vue&type=template&id=0656f566&"
import script from "./big-tree-list.vue?vue&type=script&lang=js&"
export * from "./big-tree-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports